const reducer = (state = { consent: null }, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'SET_CONSENT': {
            return { consent: payload.consent };
        }
        default:
            return state;
    }
};

export default reducer;
